// extracted by mini-css-extract-plugin
module.exports = {"siderSection":"style_siderSection__3b8-L","siderLeft":"style_siderLeft__1QOyh","tabs":"style_tabs__2qxxs","active":"style_active__2Zm0b","siderRight":"style_siderRight__2MKsI"};